import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading } from '@gull';
import Moment from 'react-moment';
import DevisA4 from "../../../app/views/Pdf/DevisA4"
import useLoadPublicDocument from './useLoadPublicDocument';
import PublicDocumentNotFound from './PublicDocumentNotFound';
import PublicPdfPreview from './PublicPdfPreview';
import {computePublicTicketTotals} from './publicTicketTotals';

/**
 * Page publique de consultation d'un devis B2C (sans authentification), affiche son PDF.
 * Un devis expiré reste consultable, avec un bandeau d'avertissement.
 */
const PublicVisualDevis = ({company,id,token}) => {
    const t = useTranslate();
    const [loading,response,error404] = useLoadPublicDocument('devis_public', company, id, token)
    const devisDetail = response.data || {}
    const section = response.section || {}
    const companyInfos = response.company || {}

    if(loading){
        return(
            <Loading></Loading>
        )
    }

    if(error404 || Object.keys(devisDetail).length==0){
        return(<PublicDocumentNotFound />)
    }

    const {totalAchat,tgcForTicketPdf,tgcTotal} = computePublicTicketTotals(devisDetail.ticket.ticket_detail, companyInfos)

    return(<>
        {devisDetail.expire &&
            <div className="alert alert-warning m-3">{t('quotationExpireAt')} <Moment format="DD/MM/YYYY">{devisDetail.validite}</Moment></div>
        }
        <PublicPdfPreview
            title="Aperçu du devis"
            document={
                <DevisA4
                    t={t}
                    documentType='quotation'
                    companyInfos={section}
                    authParam={{company:companyInfos}}
                    ticketFacture={devisDetail}
                    totalTgc={tgcTotal}
                    totalAchat={totalAchat}
                    tgcForTicketPdf={tgcForTicketPdf}
                    devise={companyInfos.devise}
                />
            }
        />
    </>)
}

export default PublicVisualDevis;
